export const parseOpeningHoursToUI = (openingHours) => {
  if (!openingHours || openingHours.length === 0) {
    return [];
  }
  const rows = [];

  const openCloseMap = {};

  openingHours.forEach((window) => {
    const key = `${window.open}-${window.close}`;
    if (!openCloseMap[key]) {
      openCloseMap[key] = [];
    }
    openCloseMap[key].push(window.day);
  });

  const combinedDays = {};
  
  Object.keys(openCloseMap).forEach((key) => {
    const openClose = key.split("-");
    const selectedDays = openCloseMap[key];
    const keyDays = selectedDays.join(",");
    if (!combinedDays[keyDays]) {
      combinedDays[keyDays] = [];
    }
    combinedDays[keyDays].push({ open: openClose[0], close: openClose[1] });
  });

  Object.keys(combinedDays).forEach((key) => {
    const days = key.split(",");
    const timeSlots = combinedDays[key].map((slot) => ({ from: slot.open, to: slot.close }));
    rows.push({ selectedDays: days, timeSlots });
  });

  return rows;
};

export const parseUIToOpeningHours = (rows) => {
  const openingHours = [];
  rows.forEach((row) => {
    row.selectedDays.forEach((day) => {
      row.timeSlots.forEach((timeSlot) => {
        openingHours.push({ day, open: timeSlot.from, close: timeSlot.to });
      });
    });
  });
  
  return openingHours;
};


export const compareOpenHoursArrays = (arr1, arr2) => {
  if (!arr1 || !arr2 || arr1.length !== arr2.length) {
    return false;
  }
  
  for (let i = 0; i < arr1.length; i++) {
    let found = false;
    for (let j = 0; j < arr2.length; j++) {
      if (arr1[i].day === arr2[j].day && arr1[i].open === arr2[j].open && arr1[i].close === arr2[j].close) {
        found = true;
        break;
      }
    }

    if (!found) {
      return false;
    }
  }

  return true;
}


